module.exports = __webpack_public_path__ + "img/sinistre.bc0b9e7c.jpg";